<template>
  <div
    v-if="noSubscriptionsForRepo"
    data-automation="no-subscription-for-repo"
  >
    <div>
      This repo is not subscribed to any sources.
    </div>
    <div style="margin-top: 1rem">
      To view packages for a repo, you must first subscribe to a source.
    </div>
    <div style="margin-top: 1rem">
      For more information, see
      <a
        :href="adminGuideURL"
        target="_blank"
      >
        the Getting Started section of the Admin Guide.
      </a>
    </div>
  </div>
  <div
    v-else-if="searchString && searchString.length < 3"
    data-automation="package-not-found-trunc"
  >
    No exact matches for "{{ searchString }}". Type 3+ characters to search.
  </div>
  <div
    v-else-if="searchString"
    data-automation="package-not-found"
  >
    No matching packages found
  </div>
  <div
    v-else
    data-automation="no-packages-found"
  >
    No packages in {{ repoName }}. Please add or sync packages.
    <div style="margin-top: 1rem">
      For more information, see
      <a
        :href="adminGuideURL"
        target="_blank"
      >
        the Getting Started section of the Admin Guide.
      </a>
    </div>
  </div>
</template>

<script>

import { serverPath } from '../api/http-common'

export default {
  name: 'NoPackages',
  props: {
    repoName: {
      type: String,
      required: true,
      default: '',
    },
    noSubscriptionsForRepo: {
      type: Boolean,
      required: true,
      default: false,
    },
    searchString: {
      type: String,
      required: true,
      default: '',
    },
  },
  computed: {
    adminGuideURL: function () {
      return `${serverPath()}__docs__/admin/getting-started/configuration/`
    },
  },
}

</script>
